export class Sizes {
  public width: number;
  public height: number;
  public pixelRatio: number;
  private onResize: (() => void) | null = null;

  constructor() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.pixelRatio = Math.min(window.devicePixelRatio, 2);

    window.addEventListener('resize', () => {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.pixelRatio = Math.min(window.devicePixelRatio, 2);
      
      if (this.onResize) {
        this.onResize();
      }
    });
  }

  public setResizeCallback(callback: () => void) {
    this.onResize = callback;
  }
}